const GAME_DATA = {
  INFO: {
    TITLE: 'WM-909',
    DESCRIPTION: 'A Whac-a-Mole Game',
    CREDITS: `A Whac-a-Mole game inspired by the
      <a href="https://en.wikipedia.org/wiki/Roland_TR-909">Roland TR-909</a>`,
  },
  GAME: {
    INTERVAL: 3000,
    DELAY: 300,
    LEVEL_INTERVAL: 5,
  },
  INSTRUCTIONS: {
    TITLE: 'Instructions',
    INSTRUCTIONS: [
      'Press the keys as they light up to gain points.',
      'The game ends when you miss a key.',
      'Tip: Try using keys 1-8 on your keyboard.',
    ],
  },
  CONTROLS: {
    START_GAME: 'Start',
    RESTART_GAME: 'Restart',
    PLAY_AGAIN: 'Play again?',
    SCORE: 'Score',
    SCORE_OVER: 'Game over',
  },
  KEYS: [
    {
      id: 'bass',
      name: 'Bass',
      key: 1,
      path: 'bass.mp3',
    },
    {
      id: 'snare',
      name: 'Snare',
      key: 2,
      path: 'snare.mp3',
    },
    {
      id: 'tom',
      name: 'Tom',
      key: 3,
      path: 'tom.mp3',
    },
    {
      id: 'clap',
      name: 'Clap',
      key: 4,
      path: 'clap.mp3',
    },
    {
      id: 'closed',
      name: 'Closed',
      key: 5,
      path: 'closed.mp3',
    },
    {
      id: 'open',
      name: 'Open',
      key: 6,
      path: 'open.mp3',
    },
    {
      id: 'crash',
      name: 'Crash',
      key: 7,
      path: 'crash.mp3',
    },
    {
      id: 'ride',
      name: 'Ride',
      key: 8,
      path: 'ride.mp3',
    },
  ],
}

export const { INFO, GAME, INSTRUCTIONS, CONTROLS, KEYS } = GAME_DATA
